import type { RangeKey } from '@dataTypes/dashboard.types'
import { VALID_DASHBOARD_DETAIL_RANGES } from '@utils/dashboardDetailSearchParams.util'

export const DASHBOARD_DETAIL_RANGE_TABS = VALID_DASHBOARD_DETAIL_RANGES.map(
  (value) => ({ label: value, value }),
) as readonly { label: RangeKey; value: RangeKey }[]

export const FINANCE_DETAIL_LOADING_CONTAINER =
  '.dashboard-finance-detail-loading-container'

export const FINANCE_DASHBOARD_LOADING_CONTAINER = '.dashboard-finance'

export const FINANCE_VS: Record<RangeKey, string> = {
  '1D': 'vs. yesterday',
  '1W': 'vs. last week',
  '1M': 'vs. last month',
  '1Y': 'vs. last year',
  YTD: 'vs. last YTD',
}

export const FINANCE_PERIOD_RIGHT_LABEL: Record<RangeKey, string> = {
  '1D': 'Today',
  '1W': 'This week',
  '1M': 'This month',
  '1Y': 'This year',
  YTD: 'YTD',
}

/** Production and collection performance grouped bars (Figma Gross/Net palette). */
export const FINANCE_GROSS_NET_BAR_COLORS = {
  gross: 'var(--blue-400)',
  net: 'var(--orange-300)',
} as const

/** Gross/Net collection line charts. */
export const FINANCE_GROSS_NET_LINE_COLORS = {
  gross: 'var(--vivid-green-400)',
  net: 'var(--teal-400)',
} as const

export const PRODUCTION_COLLECTION_SERIES = [
  {
    dataKey: 'Gross',
    name: 'Gross',
    color: FINANCE_GROSS_NET_BAR_COLORS.gross,
  },
  { dataKey: 'Net', name: 'Net', color: FINANCE_GROSS_NET_BAR_COLORS.net },
] as const

export const COLLECTION_PERFORMANCE_SERIES = [
  {
    dataKey: 'Gross',
    name: 'Gross',
    color: FINANCE_GROSS_NET_BAR_COLORS.gross,
  },
  { dataKey: 'Net', name: 'Net', color: FINANCE_GROSS_NET_BAR_COLORS.net },
] as const

export const FINANCE_INSURANCE_PATIENT_TREND_SERIES = [
  { dataKey: 'insurance', name: 'Insurance', color: 'var(--blue-500)' },
  { dataKey: 'patient', name: 'Patient', color: 'var(--teal-400)' },
] as const

export const FINANCE_PATIENT_INSURANCE_TREND_SERIES = [
  { dataKey: 'patient', name: 'Patient', color: 'var(--teal-400)' },
  { dataKey: 'insurance', name: 'Insurance', color: 'var(--blue-500)' },
] as const

export const FINANCE_DENTIST_HYGIENIST_TREND_SERIES = [
  { dataKey: 'dentist', name: 'Dentist', color: 'var(--indigo-400)' },
  { dataKey: 'hygienist', name: 'Hygienist', color: 'var(--indigo-300)' },
] as const

export const TREATMENT_VALUE_COLORS: Record<string, string> = {
  Billed: 'var(--blue-500)',
  Collected: 'var(--teal-400)',
  Potential: 'var(--vivid-green-400)',
}

export const CLAIMS_CHART_COLORS: Record<string, string> = {
  'Under review': 'var(--blue-500)',
  Paid: 'var(--vivid-green-400)',
  Pending: 'var(--yellow-400)',
  Denied: 'var(--red-400)',
}

export const CLAIMS_LEGEND_LABELS = [
  'Under review',
  'Pending',
  'Paid',
  'Denied',
] as const

export const AR_BUCKET_COLORS: Record<string, string> = {
  '0-30': 'var(--vivid-green-400)',
  '31-60': 'var(--yellow-400)',
  '61-90': 'var(--orange-400)',
  '90+': 'var(--red-500)',
}

export const AR_BUCKETS = ['0-30', '31-60', '61-90', '90+'] as const

export type ARBucket = (typeof AR_BUCKETS)[number]

/** Figma 5462:119571 — AR aging bar chart bar size. */
export const FINANCE_AR_AGING_BAR_SIZE = 100

/** Figma — production by procedure dashboard card (4 vertical bars). */
export const FINANCE_PRODUCTION_BY_PROCEDURE_BAR_SIZE = 120
export const FINANCE_PRODUCTION_BY_PROCEDURE_BAR_CATEGORY_GAP = '8%'

/** Figma 5462:119617 — treatment value bar chart bar size. */
export const FINANCE_TREATMENT_VALUE_BAR_SIZE = 150
